import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Button, message } from "antd";

import Footer from "../components/Footer";
import Header from "../components/Header";
import "./GoogleReviewLinkGenerator.css";
import "./Contact.css";

const SUPPORT_EMAIL = "support@vioo.vip";

const Contact: React.FC = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [body, setBody] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    const trimmedName = name.trim();
    const trimmedEmail = email.trim();
    const trimmedSubject = subject.trim();
    const trimmedBody = body.trim();

    if (!trimmedName || !trimmedEmail || !trimmedSubject || !trimmedBody) {
      message.warning("Please fill in all fields.");
      return;
    }

    setSubmitting(true);

    const mailBody = `Name: ${trimmedName}\nEmail: ${trimmedEmail}\n\n${trimmedBody}`;
    const mailto = `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(trimmedSubject)}&body=${encodeURIComponent(mailBody)}`;

    window.location.href = mailto;
    message.success("Opening your email app to send the message.");
    setSubmitting(false);
  };

  return (
    <div
      className="contact-page flex min-h-screen flex-col"
      style={{
        background: "linear-gradient(135deg, #1e293b 0%, #0f172a 100%)",
      }}
    >
      <Header />
      <main className="contact-main">
        <div className="contact-hero">
          <p className="contact-eyebrow">Get in touch</p>
          <h1 className="contact-title">
            <span className="contact-title-gradient">Contact Us</span>
          </h1>
          <p className="contact-subtitle">
            Questions about Vioo, pricing, or your account? Send us a message and
            our team will get back to you.
          </p>
        </div>

        <div className="contact-info-grid">
          <div className="contact-info-card">
            <span className="contact-info-label">Email</span>
            <p className="contact-info-value">
              <a href={`mailto:${SUPPORT_EMAIL}`} className="contact-info-link">
                {SUPPORT_EMAIL}
              </a>
            </p>
          </div>
          <div className="contact-info-card">
            <span className="contact-info-label">Response time</span>
            <p className="contact-info-value">
              We typically reply within 1–2 business days.
            </p>
          </div>
        </div>

        <div className="contact-form-card">
          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="contact-field">
              <label className="contact-label" htmlFor="contact-name">
                Name
              </label>
              <input
                id="contact-name"
                type="text"
                className="contact-input"
                placeholder="Your name"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </div>

            <div className="contact-field">
              <label className="contact-label" htmlFor="contact-email">
                Email
              </label>
              <input
                id="contact-email"
                type="email"
                className="contact-input"
                placeholder="you@business.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>

            <div className="contact-field">
              <label className="contact-label" htmlFor="contact-subject">
                Subject
              </label>
              <input
                id="contact-subject"
                type="text"
                className="contact-input"
                placeholder="How can we help?"
                value={subject}
                onChange={(e) => setSubject(e.target.value)}
              />
            </div>

            <div className="contact-field">
              <label className="contact-label" htmlFor="contact-message">
                Message
              </label>
              <textarea
                id="contact-message"
                className="contact-textarea"
                placeholder="Tell us more about your question..."
                value={body}
                onChange={(e) => setBody(e.target.value)}
              />
            </div>

            <Button
              type="primary"
              size="large"
              htmlType="submit"
              loading={submitting}
              className="grlg-btn-primary contact-submit"
            >
              Send message
            </Button>
          </form>
        </div>

        <p className="contact-powered-by">
          Powered by{" "}
          <Link to="/" className="contact-powered-by-link">
            Vioo.vip
          </Link>
        </p>
      </main>
      <Footer />
    </div>
  );
};

export default Contact;
